import type { CountryHub } from "./types";

export const COUNTRIES: CountryHub[] = [
  {
    slug: "uk",
    nameTh: "สหราชอาณาจักร",
    nameEn: "United Kingdom",
    flag: "🇬🇧",
    region: "ยุโรป",
    isApostille: true,
    language: "อังกฤษ",
    metaTitle: "บริการเอกสารไป UK — Notary + Apostille + แปล + วีซ่า",
    metaDesc:
      "บริการครบสำหรับเดินทาง/แต่งงาน/เรียน/ทำงานที่สหราชอาณาจักร — Notary, Apostille (UK รับ Apostille), แปลรับรอง, วีซ่า UK Visitor / Spouse / Student",
    intro:
      "สหราชอาณาจักรรับรองเอกสาร Apostille ตามอนุสัญญากรุงเฮก 1961 — เอกสารไทยต้องผ่านการรับรอง MFA (Apostille) ก่อนนำไปใช้ที่ UK เราดูแลทั้งการแปล Notary และ Apostille รวมถึงคำแนะนำการยื่นวีซ่า UK Visitor / Marriage / Student แบบครบจบในที่เดียว",
    whyUs: [
      "ทีมงานคุ้นเคยกับรูปแบบเอกสารที่หน่วยงานใน UK เรียกตรวจ",
      "แปลโดยนักแปลที่สถานทูต UK ในไทยยอมรับ",
      "เร่งด่วน MFA Apostille 1 วันได้",
    ],
    marriageServiceSlug: "marriage-uk",
    visaServiceSlug: "visa-uk-visitor",
    documentsRequired: [
      "Passport + สำเนา",
      "สูติบัตร / ทะเบียนบ้าน (พร้อมแปลรับรอง)",
      "ทะเบียนสมรส / หย่า (ถ้ามี)",
      "Bank statement 6 เดือน",
      "หนังสือรับรองสถานะโสด (CNI / Affirmation) สำหรับเคสแต่งงาน",
    ],
    steps: [
      { title: "1. แปลรับรอง", desc: "นักแปล MoJ แปลเอกสารทั้งหมดเป็นภาษาอังกฤษ" },
      { title: "2. รับรองทนาย / Notary", desc: "ทนาย Notarial Service Attorney เซ็นรับรองคำแปล" },
      { title: "3. MFA Apostille", desc: "กรมการกงสุล กระทรวงการต่างประเทศ รับรอง Apostille" },
      { title: "4. ใช้งานใน UK", desc: "นำเอกสารไปยื่นที่ Register Office / Home Office / มหาวิทยาลัยได้ทันที" },
    ],
    timeline: "5–10 วันทำการ (เร่งด่วน 1–3 วันได้)",
    costRange: "5,000–15,000 บาท ขึ้นอยู่กับจำนวนเอกสาร",
    faqs: [
      {
        q: "UK รับ Apostille หรือยังต้องไปสถานทูต?",
        a: "UK เป็นสมาชิก Hague Apostille Convention — ใช้ Apostille ของ MFA ไทยได้เลย ไม่ต้องไปรับรองที่สถานทูต UK ในไทย (ยกเว้นบางเคสพิเศษ)",
      },
      {
        q: "ขอ CNI (Certificate of No Impediment) ที่ไหน?",
        a: "ขอที่ UK General Register Office ใช้เวลา 28 วัน + 7 วันรอประกาศ — หรือถ้าฝ่าย UK อยู่ไทยขอที่ British Embassy Bangkok",
      },
    ],
    tips: [
      "Apostille ของไทยมีอายุ 6 เดือนตามมาตรฐาน Register Office ส่วนใหญ่",
      "ต้องมี Translation Certificate แนบทุกชุดเอกสาร",
    ],
    relatedServiceSlugs: ["mfa-consular", "notary-public-english", "translation-certified-all", "marriage-uk", "visa-uk-visitor"],
  },
  {
    slug: "usa",
    nameTh: "สหรัฐอเมริกา",
    nameEn: "United States",
    flag: "🇺🇸",
    region: "อเมริกาเหนือ",
    isApostille: true,
    language: "อังกฤษ",
    metaTitle: "เอกสารไป USA — Apostille + B1/B2 + Las Vegas Wedding",
    metaDesc:
      "บริการเอกสารและวีซ่าสำหรับเดินทางไปสหรัฐอเมริกา — Apostille, แปลรับรอง, จดทะเบียนสมรสที่ Las Vegas, วีซ่า B1/B2 ครบจบในที่เดียว",
    intro:
      "สหรัฐอเมริการับเอกสาร Apostille — เอกสารไทยต้องผ่าน MFA Apostille ก่อนใช้งานในรัฐต่าง ๆ เราเชี่ยวชาญทั้งการเตรียมเอกสารแต่งงานที่ Las Vegas / Hawaii และวีซ่าท่องเที่ยว/ธุรกิจ B1/B2",
    whyUs: [
      "ดูแลเอกสารแต่งงานที่สหรัฐฯ และการบันทึกฐานะแห่งครอบครัวกลับไทย",
      "เตรียม Affidavit + Notary แบบ US standard",
      "ติว Interview B1/B2 ก่อนสัมภาษณ์",
    ],
    marriageServiceSlug: "marriage-las-vegas",
    visaServiceSlug: "visa-us-b1b2",
    documentsRequired: [
      "Passport + รูปถ่าย US visa size (5x5cm)",
      "DS-160 confirmation page",
      "Bank statement 6 เดือน + slip เงินเดือน 3 เดือน",
      "Affidavit of Single Status (สำหรับ Las Vegas marriage)",
      "Itinerary + จองโรงแรม",
    ],
    steps: [
      { title: "1. เตรียมเอกสาร", desc: "แปล + Notary ทุกเอกสารทางการเงินและสถานะ" },
      { title: "2. Apostille (ถ้าจำเป็น)", desc: "MFA Apostille สำหรับเอกสารแต่งงาน/รับรองบุตร" },
      { title: "3. กรอก DS-160 + ชำระค่าธรรมเนียม", desc: "ทีมช่วยกรอกและจองคิวสัมภาษณ์" },
      { title: "4. ติว interview", desc: "Mock interview 1 ชั่วโมงกับทนาย" },
    ],
    timeline: "วีซ่า 3–8 สัปดาห์ • เอกสารแต่งงาน 7–10 วันทำการ",
    costRange: "5,000–20,000 บาท (ไม่รวมค่าธรรมเนียม visa)",
    faqs: [
      {
        q: "Las Vegas marriage ใช้แค่ passport ใช่ไหม?",
        a: "พื้นฐานใช่ — แต่ถ้าต้องการให้ไทยรับรองภายหลัง ต้องนำ Marriage Certificate ไป Apostille ที่ Nevada Secretary of State + แปลรับรอง + MFA ไทย จึงจะจดทะเบียนกลับไทยได้",
      },
      {
        q: "B1/B2 อนุมัติยากไหมจากภูเก็ต?",
        a: "Approval rate ของคนภูเก็ตอยู่ราว 75–80% ถ้าเตรียมเอกสารดีและมีหลักฐานเชื่อมโยงกลับไทยชัด เราช่วยจัดเอกสารและ Mock interview เพื่อเพิ่มโอกาส",
      },
    ],
    relatedServiceSlugs: ["mfa-consular", "marriage-las-vegas", "visa-us-b1b2", "notary-public-english"],
  },
  {
    slug: "australia",
    nameTh: "ออสเตรเลีย",
    nameEn: "Australia",
    flag: "🇦🇺",
    region: "โอเชียเนีย",
    isApostille: false,
    language: "อังกฤษ (NAATI)",
    metaTitle: "เอกสารไป Australia — NAATI + Visa 600 + Marriage",
    metaDesc:
      "เอกสารและวีซ่าออสเตรเลียครบจบในที่เดียว — แปลรับรอง NAATI, วีซ่า Tourist 600 / Partner / Student, จดทะเบียนสมรสที่ออสเตรเลีย",
    intro:
      "ออสเตรเลียไม่ใช่สมาชิก Apostille — เอกสารต้องผ่าน MFA + รับรองที่สถานทูตออสเตรเลียในกรุงเทพ และต้องแปลโดยนักแปล NAATI accredited เท่านั้นจึงจะใช้ได้",
    whyUs: [
      "นักแปล NAATI ในทีม — ไม่ต้องส่งงานออก",
      "เคสวีซ่า 600 / Partner — เตรียมชุดเอกสารตามเกณฑ์ Home Affairs",
      "ส่งงาน NAATI Online ทั่วโลก ภายใน 48 ชม.",
    ],
    marriageServiceSlug: "marriage-australia",
    visaServiceSlug: "visa-australia-600",
    documentsRequired: [
      "Passport + รูปถ่าย",
      "Bank statement 3 เดือน + Tax invoice",
      "Letter of Invitation (ถ้ามี)",
      "หลักฐานการทำงาน / leave approval",
      "Health Insurance + จองตั๋ว",
    ],
    steps: [
      { title: "1. แปล NAATI", desc: "นักแปล NAATI accredited แปลและประทับตรา" },
      { title: "2. ยื่นเอกสาร online", desc: "ผ่าน ImmiAccount พร้อมแนบเอกสารทั้งหมด" },
      { title: "3. Biometrics", desc: "VFS Bangkok / Phuket VAC ถ่ายลายนิ้วมือ" },
      { title: "4. รอผล + รับ visa grant", desc: "Tourist 600 ใช้เวลา 15–28 วัน" },
    ],
    timeline: "วีซ่า 15–45 วัน • NAATI 1–2 วันทำการ",
    costRange: "วีซ่า 4,500–8,000 บาท • NAATI 1,300–2,500 บาท/หน้า",
    faqs: [
      {
        q: "ทำไมต้อง NAATI เท่านั้น?",
        a: "Department of Home Affairs ของออสเตรเลียกำหนดให้ใช้นักแปลที่ขึ้นทะเบียน NAATI (National Accreditation Authority for Translators and Interpreters) เท่านั้นสำหรับเอกสารที่ไม่ใช่ภาษาอังกฤษ",
      },
      {
        q: "ภูเก็ตมี VAC ไหม?",
        a: "ไม่มี ต้องไป VFS Australia ที่กรุงเทพ (อาคารเทรนดี้ สุขุมวิท 13) หรือเชียงใหม่ — เราจัดทีมพาเดินทางได้",
      },
    ],
    relatedServiceSlugs: ["naati", "naati-online", "visa-australia-600", "marriage-australia", "embassy-legalization"],
  },
  {
    slug: "germany",
    nameTh: "เยอรมนี",
    nameEn: "Germany",
    flag: "🇩🇪",
    region: "ยุโรป",
    isApostille: true,
    language: "เยอรมัน (ทนายเยอรมัน)",
    metaTitle: "บริการเอกสารไป Germany — Apostille + แปลเยอรมัน + Visa",
    metaDesc:
      "บริการครบสำหรับเดินทาง/แต่งงาน/เรียนที่เยอรมนี — แปลเยอรมันโดยนักแปลขึ้นทะเบียน, Apostille, รับรองสถานทูตเยอรมัน, วีซ่า Schengen",
    intro:
      "เยอรมนีเป็นสมาชิก Apostille — แต่เอกสารต้องแปลเป็นภาษาเยอรมันโดยนักแปลที่สถานทูตเยอรมันยอมรับ (Beglaubigte Übersetzung) เราดูแลครบตั้งแต่แปล Apostille จนถึงรับรองสถานทูต",
    whyUs: [
      "นักแปลเยอรมันได้รับการรับรองจากสถานทูตเยอรมัน",
      "เคส Familienzusammenführung (รวมครอบครัว) >100 เคส",
      "เร่งด่วน Schengen approval ภายใน 7–10 วัน",
    ],
    marriageServiceSlug: "marriage-germany",
    visaServiceSlug: "visa-schengen",
    documentsRequired: [
      "Ehefähigkeitszeugnis (CNI) จากเยอรมัน",
      "สูติบัตร + ทะเบียนบ้าน แปลเยอรมัน + Apostille",
      "Schufa-Auskunft (ถ้ายื่น Familienzusammenführung)",
      "Bank statement + Verpflichtungserklärung",
    ],
    steps: [
      { title: "1. รวบรวมเอกสารไทย", desc: "ขอเอกสารต้นฉบับจากเขต/อำเภอ" },
      { title: "2. แปลเยอรมัน", desc: "นักแปลรับรองโดยสถานทูตเยอรมัน" },
      { title: "3. MFA Apostille", desc: "รับรอง Apostille ที่กรมการกงสุล" },
      { title: "4. รับรองสถานทูตเยอรมัน", desc: "นำเอกสารไปรับรองที่สถานทูตเยอรมัน กรุงเทพ" },
    ],
    timeline: "10–20 วันทำการ • วีซ่า Schengen 15–30 วัน",
    costRange: "8,000–25,000 บาท ขึ้นอยู่กับจำนวนเอกสาร",
    faqs: [
      {
        q: "Apostille พอไหม หรือต้องไปสถานทูตเยอรมันด้วย?",
        a: "สำหรับเอกสารทะเบียนราษฎร (สูติบัตร ทะเบียนสมรส) สถานทูตเยอรมันต้องตรวจ + ออก Vorprüfung เพิ่ม ไม่ได้ใช้ Apostille เพียงอย่างเดียว",
      },
      {
        q: "นานเท่าไรถึงได้ Ehefähigkeitszeugnis?",
        a: "ปกติ 4–8 สัปดาห์จาก Standesamt เมืองที่ฝ่ายเยอรมันอาศัย",
      },
    ],
    relatedServiceSlugs: ["mfa-consular", "embassy-legalization", "marriage-germany", "visa-schengen"],
  },
  {
    slug: "japan",
    nameTh: "ญี่ปุ่น",
    nameEn: "Japan",
    flag: "🇯🇵",
    region: "เอเชีย",
    isApostille: true,
    language: "ญี่ปุ่น",
    metaTitle: "บริการเอกสารไป Japan — Apostille + แปลญี่ปุ่น +",
    metaDesc:
      "บริการเอกสารและวีซ่าสำหรับเดินทางไปญี่ปุ่น — แปลญี่ปุ่น, Apostille, จดทะเบียนสมรสที่ Kuyakusho, วีซ่าท่องเที่ยว Single/Multiple",
    intro:
      "ญี่ปุ่นเป็นสมาชิก Apostille — เอกสารไทยใช้ Apostille MFA ได้เลย แต่ต้องแปลเป็นภาษาญี่ปุ่นโดยนักแปลที่สถานทูตยอมรับ เรามีนักแปลญี่ปุ่นในทีมเตรียมงานได้ภายใน 2–3 วัน",
    whyUs: [
      "นักแปลญี่ปุ่น native + JLPT N1",
      "เคสจดทะเบียนสมรสที่ Kuyakusho >80 เคส",
      "ติดต่อสถานทูตญี่ปุ่นในไทยได้รวดเร็ว",
    ],
    marriageServiceSlug: "marriage-japan",
    visaServiceSlug: "visa-japan-tourist",
    documentsRequired: [
      "Passport + รูปถ่าย 4.5x4.5 cm",
      "ใบสมัครวีซ่าญี่ปุ่น + ตารางท่องเที่ยว",
      "Bank statement 6 เดือน + slip 3 เดือน",
      "Konin Yoken Gubi Shomeisho (สำหรับสมรส)",
    ],
    steps: [
      { title: "1. เตรียมเอกสาร", desc: "แปลและรับรองเอกสารทางการเงิน" },
      { title: "2. Apostille (สมรส)", desc: "MFA Apostille สำหรับเอกสารทะเบียนราษฎร" },
      { title: "3. ยื่นที่ VFS Japan", desc: "Phuket / Bangkok VAC" },
      { title: "4. รับ visa + เดินทาง", desc: "Tourist Single Entry 15 วัน" },
    ],
    timeline: "วีซ่า 5–10 วันทำการ",
    costRange: "วีซ่า 1,500–3,500 บาท • เอกสารสมรส 6,000–12,000 บาท",
    faqs: [
      {
        q: "วีซ่าญี่ปุ่น Multiple ขอได้ตอนไหน?",
        a: "ปกติต้องเคยไปญี่ปุ่นมาแล้ว 2 ครั้งในรอบ 3 ปี หรือมีเงินเดือน/ฐานะทางการเงินที่สูงเพียงพอ",
      },
      {
        q: "Kuyakusho ที่ไหนรับจดทะเบียน?",
        a: "Ku/Shi-yakusho ของเขตที่ฝ่ายญี่ปุ่นมีทะเบียนบ้าน (Juminhyo) — ใช้เวลา 1 วัน ถ้าเอกสารครบ",
      },
    ],
    relatedServiceSlugs: ["mfa-consular", "marriage-japan", "visa-japan-tourist", "translation-certified-all"],
  },
  {
    slug: "denmark",
    nameTh: "เดนมาร์ก",
    nameEn: "Denmark",
    flag: "🇩🇰",
    region: "ยุโรป",
    isApostille: true,
    language: "อังกฤษ/เดนมาร์ก",
    metaTitle: "บริการเอกสารไป Denmark — Apostille + จดทะเบียนสมรส Aeroe",
    metaDesc: "บริการครบสำหรับการแต่งงานที่เดนมาร์ก (Aeroe / Copenhagen) — เอกสารเร็ว 7 วัน, Apostille, แปลรับรอง, รวมจดทะเบียนกลับไทย บริการครบทั้งเอกสาร Apostille",
    intro:
      "เดนมาร์กเป็น destination ยอดนิยมสำหรับการแต่งงานเพราะใช้เอกสารน้อยและขั้นตอนเร็ว — ที่ Aeroe Kommune ใช้เวลาเพียง 2–3 วัน เราดูแลตั้งแต่ Apostille จนถึงจดทะเบียนกลับไทย",
    whyUs: [
      "คุ้นเคยขั้นตอนจดทะเบียนสมรสที่ Ærø Kommune และเอกสารที่ต้องใช้",
      "ดูแลทุกขั้นตอนจนกลับไทยจดทะเบียนเสร็จ",
      "แพ็คเกจ All-in-one + booking ที่พัก",
    ],
    marriageServiceSlug: "marriage-denmark",
    documentsRequired: [
      "Passport + รูปถ่าย",
      "สูติบัตร + ทะเบียนบ้าน + Apostille",
      "หนังสือรับรองสถานะโสด + Apostille",
      "ทะเบียนหย่า (ถ้ามี) + Apostille",
    ],
    steps: [
      { title: "1. รวบรวมเอกสารไทย", desc: "ขอเอกสารทะเบียนราษฎร + แปล + รับรอง" },
      { title: "2. MFA Apostille", desc: "Apostille ทั้ง 4 ฉบับ" },
      { title: "3. ยื่นที่ Aeroe Kommune", desc: "Online application รอ approval 5–10 วัน" },
      { title: "4. แต่งงาน + กลับไทย", desc: "Apostille marriage certificate + จดทะเบียนกลับไทย" },
    ],
    timeline: "เตรียมเอกสาร 7–10 วัน • Aeroe approval 5–10 วัน",
    costRange: "แพ็คเกจ 15,000–25,000 บาท (ไม่รวมค่าใช้จ่ายในเดนมาร์ก)",
    faqs: [
      {
        q: "ทำไมต้อง Aeroe ไม่ใช่ Copenhagen?",
        a: "Aeroe Kommune ยืดหยุ่นเรื่องเอกสาร ใช้เวลาน้อย และไม่ต้องอยู่ในเดนมาร์กก่อนแต่ง — Copenhagen เข้มงวดและต้องรอนาน",
      },
    ],
    relatedServiceSlugs: ["mfa-consular", "marriage-denmark", "marriage-abroad"],
  },
  {
    slug: "singapore",
    nameTh: "สิงคโปร์",
    nameEn: "Singapore",
    flag: "🇸🇬",
    region: "เอเชีย",
    isApostille: true,
    language: "อังกฤษ",
    metaTitle: "บริการเอกสารไป Singapore — ROM Wedding + Notary + Apostille",
    metaDesc: "บริการครบสำหรับจดทะเบียนสมรสที่ ROM Singapore — เอกสาร, Apostille, แปลรับรอง, รวมจดทะเบียนกลับไทย บริการครบทั้งเอกสาร Apostille",
    intro:
      "สิงคโปร์เป็นสมาชิก Apostille (ตั้งแต่ ม.ค. 2022) — เอกสารไทยใช้ Apostille MFA ได้ จดทะเบียนที่ Registry of Marriages (ROM) ใช้เวลาเพียง 21 วัน notice period",
    whyUs: [
      "เคส ROM Wedding >60 เคส",
      "เข้าใจขั้นตอน Notice of Marriage online",
      "ดูแลจดทะเบียนกลับไทยให้ครบ",
    ],
    marriageServiceSlug: "marriage-singapore",
    documentsRequired: [
      "Passport",
      "สูติบัตร + Apostille",
      "หนังสือรับรองสถานะโสด + Apostille",
      "ทะเบียนหย่า (ถ้ามี) + Apostille",
    ],
    steps: [
      { title: "1. เตรียมเอกสาร + Apostille", desc: "MFA Apostille ทั้ง 3–4 ฉบับ" },
      { title: "2. File Notice of Marriage", desc: "Online ผ่าน ROM website + ค่าธรรมเนียม S$42" },
      { title: "3. รอ 21 วัน notice period", desc: "ต้องเข้าสิงคโปร์ก่อน 14 วันก่อนวันจด" },
      { title: "4. Solemnization + Apostille", desc: "จดที่ ROM + Apostille marriage cert" },
    ],
    timeline: "Notice 21 วัน + เตรียมเอกสาร 7 วัน",
    costRange: "แพ็คเกจไทย 10,000–18,000 บาท",
    faqs: [
      {
        q: "ต้องอาศัยในสิงคโปร์กี่วันก่อนแต่ง?",
        a: "ต้องเข้าสิงคโปร์อย่างน้อย 14 จาก 21 วันก่อนแต่ง — แต่บางเคส ROM ผ่อนผันให้ Tourist ที่มาแต่งงานชัดเจน",
      },
      {
        q: "เอกสารไทยใช้ที่สิงคโปร์ต้องทำ Apostille ไหม",
        a: "สิงคโปร์เป็นภาคีอนุสัญญากรุงเฮกตั้งแต่ ก.ย. 2021 จึงรับ Apostille ของกรมการกงสุลไทยพร้อมคำแปลภาษาอังกฤษที่รับรองถูกต้อง ไม่ต้องผ่านสถานทูตอีกชั้น",
      },
      {
        q: "Notice of Marriage ยื่นออนไลน์ล่วงหน้าได้กี่วัน",
        a: "ยื่นผ่านเว็บไซต์ ROM ได้ล่วงหน้าไม่เกิน 3 เดือน และต้องเว้นอย่างน้อย 21 วันก่อนวันพิธี ใบอนุญาตมีอายุจำกัด จึงควรยืนยันวัน solemnization ก่อนออกตั๋ว",
      },
      {
        q: "ต้องมีพยานกี่คน",
        a: "ต้องมีพยานอายุ 21 ปีขึ้นไป 2 คนในวันพิธี ROM ไม่ได้จัดพยานให้ จึงควรเตรียมล่วงหน้าหรือแจ้งทีมเราให้ประสาน",
      },
      {
        q: "จดที่ ROM แล้วบันทึกกลับไทยอย่างไร",
        a: "ขอ Marriage Certificate (Digital/Certified) แล้วทำ Apostille ที่ Singapore Academy of Law จากนั้นแปลไทย รับรอง และบันทึก คร.22 ที่อำเภอ",
      },
      {
        q: "คู่รักเพศเดียวกันจดทะเบียนที่สิงคโปร์ได้ไหม",
        a: "ปัจจุบันกฎหมายสิงคโปร์ยังไม่รองรับการสมรสเพศเดียวกัน ทีมเราแนะนำเส้นทางอื่น เช่น เดนมาร์ก หรือการจดทะเบียนสมรสในประเทศไทยตามกฎหมายสมรสเท่าเทียม",
      },
    ],
    relatedServiceSlugs: ["mfa-consular", "marriage-singapore", "marriage-abroad"],
  },
  {
    slug: "hong-kong",
    nameTh: "ฮ่องกง",
    nameEn: "Hong Kong",
    flag: "🇭🇰",
    region: "เอเชีย",
    isApostille: true,
    language: "อังกฤษ",
    metaTitle: "บริการเอกสารไป Hong Kong — จดทะเบียนสมรส Marriage Registry",
    metaDesc: "บริการครบสำหรับจดทะเบียนสมรสที่ฮ่องกง — เอกสาร, Apostille, แปลอังกฤษ, จดทะเบียนกลับไทย บริการครบทั้งเอกสาร Apostille แปลรับรองและคำปรึกษาวีซ่าโดยทีมทนายภูเก็ต",
    intro:
      "ฮ่องกงรับ Apostille ตามอนุสัญญากรุงเฮก — จดทะเบียนสมรสที่ Marriage Registry ของ Immigration Department ใช้เวลาเพียง 15 วัน notice + ค่าธรรมเนียม HK$715",
    whyUs: [
      "เคสจดทะเบียนที่ HK Marriage Registry >40 เคส",
      "ติดต่อ Civil Celebrant ถ้าต้องการแต่งนอกสถานที่",
    ],
    marriageServiceSlug: "marriage-hongkong",
    documentsRequired: [
      "Passport",
      "สูติบัตร + Apostille",
      "Single Status Certificate + Apostille",
      "ทะเบียนหย่า (ถ้ามี) + Apostille",
    ],
    steps: [
      { title: "1. เตรียมเอกสาร + Apostille", desc: "MFA Apostille + แปลรับรองอังกฤษ" },
      { title: "2. Give Notice (Online)", desc: "ผ่าน GovHK 15 วันก่อนวันแต่ง" },
      { title: "3. Attend Registry", desc: "ทั้งสองฝ่ายต้องอยู่ในฮ่องกงตอนแต่ง" },
      { title: "4. Apostille + จดกลับไทย", desc: "Apostille marriage cert ที่ HK High Court" },
    ],
    timeline: "Notice 15 วัน + เตรียมเอกสาร 5–7 วัน",
    costRange: "8,000–15,000 บาท ฝั่งไทย",
    faqs: [
      {
        q: "เอกสารไทยที่ใช้ในฮ่องกงต้องทำ Apostille หรือรับรองกงสุล?",
        a: "ฮ่องกง (HKSAR) อยู่ในระบบอนุสัญญากรุงเฮก และประเทศไทยเริ่มออก Apostille ผ่านกรมการกงสุลแล้ว จึงใช้ Apostille ได้โดยไม่ต้องผ่านสถานกงสุลจีน/ฮ่องกงอีกชั้น อย่างไรก็ตามหน่วยงานปลายทางแต่ละแห่งมีดุลพินิจของตนเอง ทีมงานจึงยืนยันรูปแบบที่ผู้รับเอกสารต้องการก่อนเริ่มงานเสมอ",
      },
      {
        q: "Notice of Intended Marriage ที่ฮ่องกงมีอายุเท่าไร",
        a: "โดยทั่วไป 3 เดือนนับจากวันยื่น และต้องเว้นอย่างน้อย 15 วันก่อนวันพิธี หากเลยกำหนดต้องยื่นใหม่และนับ 15 วันใหม่ทั้งหมด จึงควรจองตั๋วหลังได้วันพิธีที่ยืนยันแล้ว",
      },
      {
        q: "คนไทยต้องขอวีซ่าเข้าฮ่องกงเพื่อจดทะเบียนไหม",
        a: "ผู้ถือหนังสือเดินทางไทยเข้าฮ่องกงได้ตามระยะเวลาที่ Immigration Department กำหนดโดยไม่ต้องขอวีซ่าล่วงหน้า และการสมรสไม่ต้องมีสถานะพำนัก แต่ทั้งคู่ต้องอยู่ในฮ่องกงจริงในวันพิธี",
      },
      {
        q: "จดทะเบียนที่ฮ่องกงแล้วต้องทำอะไรต่อในไทย",
        a: "นำ Marriage Certificate ฉบับจริงไป Apostille ที่ High Court of Hong Kong แล้วแปลเป็นไทยพร้อมรับรอง จากนั้นบันทึกฐานะแห่งครอบครัว (คร.22) ที่สำนักทะเบียนอำเภอ/เขต ในภูเก็ตเราดำเนินการแทนได้ทั้งกระบวนการ",
      },
      {
        q: "ถ้าเคยหย่ามาก่อนต้องเตรียมอะไรเพิ่ม",
        a: "ต้องมีใบสำคัญการหย่าหรือคำพิพากษาถึงที่สุด พร้อมคำแปลภาษาอังกฤษที่รับรองถูกต้อง และรับรองตามรูปแบบที่ Registry ยอมรับ เอกสารชุดนี้เป็นสาเหตุตีกลับอันดับต้น ๆ ของเคสฮ่องกง",
      },
      {
        q: "พิธีที่ Registry กับ Civil Celebrant ต่างกันอย่างไร",
        a: "Registry จัดที่สำนักงานราชการ ค่าธรรมเนียมต่ำกว่าและจัดพยานให้ ส่วน Civil Celebrant จัดพิธีนอกสถานที่ได้ (โรงแรม เรือ ร้านอาหาร) แต่ผู้จดต้องเตรียมพยาน 2 คนเอง และมีค่าใช้จ่ายสูงกว่า",
      },
    ],
    relatedServiceSlugs: ["mfa-consular", "marriage-hongkong", "marriage-abroad"],
  },
  {
    slug: "new-zealand",
    nameTh: "นิวซีแลนด์",
    nameEn: "New Zealand",
    flag: "🇳🇿",
    region: "โอเชียเนีย",
    isApostille: true,
    language: "อังกฤษ",
    metaTitle: "บริการเอกสารไป New Zealand — Apostille + Marriage + Visa",
    metaDesc: "บริการเอกสารและวีซ่านิวซีแลนด์ — Apostille, แปลรับรอง, จดทะเบียนสมรสที่ NZ, NAATI สำหรับ visa บริการครบทั้งเอกสาร Apostille",
    intro:
      "นิวซีแลนด์เป็นสมาชิก Apostille — เอกสารไทยใช้ Apostille MFA ได้ จดทะเบียนสมรสที่ BDM (Births, Deaths and Marriages) สามารถแต่งได้ทั่วประเทศ",
    whyUs: ["เคส NZ Marriage + Visitor visa >30 เคส", "แปลโดยนักแปลที่ NZ Immigration ยอมรับ"],
    marriageServiceSlug: "marriage-new-zealand",
    documentsRequired: [
      "Passport",
      "สูติบัตร + Apostille + แปลอังกฤษ",
      "Single Status + Apostille",
      "Bank statement + Itinerary",
    ],
    steps: [
      { title: "1. เตรียมเอกสาร", desc: "Apostille + แปลรับรอง" },
      { title: "2. Notice of Intended Marriage", desc: "ยื่นล่วงหน้า 3 วันทำการ" },
      { title: "3. แต่งงาน + รับ Marriage Certificate", desc: "ที่ Registry Office หรือ Celebrant" },
      { title: "4. Apostille + จดกลับไทย", desc: "Apostille โดย DIA + นำกลับไทย" },
    ],
    timeline: "เตรียมเอกสาร 7–10 วัน",
    costRange: "10,000–18,000 บาท",
    faqs: [
      {
        q: "เอกสารไทยใช้ในนิวซีแลนด์ต้องรับรองแบบไหน",
        a: "นิวซีแลนด์เป็นภาคีอนุสัญญากรุงเฮก จึงรับ Apostille ที่ออกโดยกรมการกงสุลของไทย พร้อมคำแปลภาษาอังกฤษที่รับรองถูกต้อง หน่วยงานปลายทาง เช่น BDM หรือ Immigration New Zealand มีดุลพินิจขอเอกสารเพิ่มได้",
      },
      {
        q: "Notice of Intended Marriage ที่ NZ ต้องยื่นล่วงหน้ากี่วัน",
        a: "ยื่นต่อ Registrar ล่วงหน้าอย่างน้อย 3 วันทำการ และใบอนุญาต (Marriage Licence) มีอายุ 3 เดือน จึงวางแผนเดินทางได้ยืดหยุ่นกว่าฮ่องกงหรือสิงคโปร์",
      },
      {
        q: "ต้องแปลเอกสารโดย NAATI ไหม",
        a: "NAATI เป็นระบบของออสเตรเลีย ส่วนนิวซีแลนด์รับคำแปลจากนักแปลอาชีพที่ระบุคุณสมบัติและลงนามรับรอง (บางกรณีอ้างอิง NZSTI) ทีมเราจัดคำแปลตามข้อกำหนดของหน่วยงานที่คุณจะยื่นให้ตรงแบบ",
      },
      {
        q: "จดทะเบียนที่นิวซีแลนด์แล้วมีผลในไทยทันทีหรือไม่",
        a: "ไม่ทันที ต้องนำทะเบียนสมรสไป Apostille โดย Department of Internal Affairs แปลเป็นไทยและรับรอง แล้วจึงบันทึก คร.22 ที่อำเภอ",
      },
      {
        q: "ขอวีซ่าคู่หมั้น/คู่สมรสไปนิวซีแลนด์ต้องใช้เอกสารอะไร",
        a: "โดยทั่วไปต้องแสดงหลักฐานความสัมพันธ์ที่แท้จริง (living together evidence) การเงินของผู้สนับสนุน และเอกสารสถานะโสด/หย่า ผลการพิจารณาขึ้นกับดุลพินิจของ Immigration New Zealand",
      },
      {
        q: "ทีมงานที่ภูเก็ตช่วยอะไรได้บ้างหากพิธีอยู่ที่ NZ",
        a: "เราดูแลฝั่งไทยทั้งหมด — หนังสือรับรองสถานะโสด สูติบัตร คำแปล Apostille การรับรองลายมือชื่อโดยทนายผู้ทำคำรับรองลายมือชื่อ และการบันทึกทะเบียนกลับไทยหลังพิธี",
      },
    ],
    relatedServiceSlugs: ["mfa-consular", "marriage-new-zealand", "naati"],
  },
  {
    slug: "canada",
    nameTh: "แคนาดา",
    nameEn: "Canada",
    flag: "🇨🇦",
    region: "อเมริกาเหนือ",
    isApostille: true,
    language: "อังกฤษ/ฝรั่งเศส",
    metaTitle: "บริการเอกสารไป Canada — Apostille + แปล + Visitor Visa (TRV)",
    metaDesc: "บริการเอกสารและ Visitor Visa (TRV) ของแคนาดา — Apostille, แปลรับรอง, IRCC documents บริการครบทั้งเอกสาร Apostille แปลรับรองและคำปรึกษาวีซ่าโดยทีมทนายภูเก็ต",
    intro:
      "แคนาดาเข้าร่วม Apostille Convention เมื่อ ม.ค. 2024 — เอกสารไทยใช้ Apostille MFA ได้ ไม่ต้องไปสถานทูตแคนาดาในไทยอีกต่อไป",
    whyUs: ["รู้เกณฑ์ใหม่ของ IRCC หลัง Apostille rollout", "Approval rate Visitor TRV >85%"],
    visaServiceSlug: "visa-canada",
    documentsRequired: [
      "Passport + รูปถ่าย Canada visa size",
      "IMM 5257 + IMM 5645",
      "Bank statement 6 เดือน + Tax invoice",
      "Itinerary + Letter of Invitation (ถ้ามี)",
    ],
    steps: [
      { title: "1. เตรียมเอกสาร + แปล", desc: "แปลรับรองทุกเอกสารทางการเงิน" },
      { title: "2. ยื่น Online ผ่าน IRCC", desc: "Upload + จ่ายค่าธรรมเนียม" },
      { title: "3. Biometrics ที่ VFS", desc: "Bangkok หรือ Chiang Mai" },
      { title: "4. รอผล 30–60 วัน", desc: "Visitor TRV หรือ Super Visa" },
    ],
    timeline: "วีซ่า 30–60 วัน",
    costRange: "8,000–15,000 บาท + ค่าธรรมเนียม VFS",
    faqs: [
      {
        q: "แคนาดาเข้าร่วม Apostille แล้วยังต้องรับรองสถานทูตอยู่ไหม",
        a: "แคนาดาเริ่มใช้ Apostille ตั้งแต่ 11 ม.ค. 2024 เอกสารราชการไทยที่ผ่าน Apostille จึงใช้ได้โดยไม่ต้องผ่านสถานทูตแคนาดา แต่หน่วยงานผู้รับในแคนาดา (เช่น จังหวัดหรือ IRCC) อาจกำหนดรูปแบบคำแปลเพิ่มเติม",
      },
      {
        q: "IRCC รับคำแปลแบบไหน",
        a: "IRCC กำหนดให้คำแปลทำโดยนักแปลอาชีพ พร้อม affidavit หรือคำรับรองของผู้แปลเมื่อผู้แปลไม่ใช่นักแปลที่ได้รับรองในแคนาดา ทีมเราจัดชุดคำแปล + คำรับรอง + รับรองลายมือชื่อโดยทนายให้ครบตามแบบ",
      },
      {
        q: "ยื่น Visitor Visa (TRV) ใช้เวลานานแค่ไหน",
        a: "ระยะเวลาพิจารณาเปลี่ยนแปลงตามปริมาณคำขอ โดยทั่วไปประมาณ 30–60 วันหลังเก็บ biometrics ควรตรวจเวลาปัจจุบันจาก canada.ca ก่อนจองตั๋ว ผลการอนุมัติเป็นดุลพินิจของเจ้าหน้าที่",
      },
      {
        q: "ต้องเก็บ Biometrics ที่ไหนในไทย",
        a: "ที่ VFS Global ในกรุงเทพฯ หรือเชียงใหม่ ลูกค้าภูเก็ตส่วนใหญ่รวมรอบเดินทางหนึ่งครั้ง ทีมเราจัดคิวและเตรียมเอกสารให้ครบก่อนขึ้นเครื่อง",
      },
      {
        q: "ใบตรวจประวัติอาชญากรรมไทยใช้กับแคนาดาได้ไหม",
        a: "ใช้ได้ โดยขอจากกองบัญชาการตำรวจสันติบาล แล้วแปลอังกฤษ + Apostille ทีมเราดำเนินการยื่นแทนได้ทั้งกรณีอยู่ไทยและอยู่ต่างประเทศ",
      },
      {
        q: "จดทะเบียนสมรสที่แคนาดาแล้วบันทึกกลับไทยอย่างไร",
        a: "นำ Marriage Certificate ของจังหวัดนั้นไป Apostille แปลไทยและรับรอง จากนั้นบันทึก คร.22 ที่อำเภอในไทย",
      },
    ],
    relatedServiceSlugs: ["visa-canada", "mfa-consular", "translation-certified-all"],
  },
  {
    slug: "schengen",
    nameTh: "Schengen (ยุโรป 27 ประเทศ)",
    nameEn: "Schengen Area",
    flag: "🇪🇺",
    region: "ยุโรป",
    isApostille: true,
    language: "อังกฤษ/ภาษาประเทศปลายทาง",
    metaTitle: "Schengen Visa — เอกสารยื่นยุโรป 27 ประเทศ",
    metaDesc: "Schengen visa C-type สำหรับเดินทาง 27 ประเทศยุโรป — เอกสาร, แปล, Travel Insurance, Itinerary ครบจบ บริการครบทั้งเอกสาร Apostille",
    intro:
      "Schengen Area ครอบคลุม 27 ประเทศยุโรป — Visa C-type อยู่ได้สูงสุด 90 วันใน 180 วัน ต้องยื่นที่สถานทูตของประเทศหลักที่จะอยู่นานที่สุด",
    whyUs: [
      "เคส Schengen visa >300 ใบ — Approval rate >92%",
      "เตรียม Itinerary + Insurance ครบตาม requirement",
      "เลือกประเทศยื่นที่อนุมัติง่ายให้",
    ],
    visaServiceSlug: "visa-schengen",
    documentsRequired: [
      "Passport + รูปถ่าย Schengen 3.5x4.5cm",
      "Travel Insurance ≥30,000 EUR",
      "Bank statement 6 เดือน + Tax invoice",
      "Itinerary + จองตั๋วเครื่องบิน + โรงแรม",
      "Letter of Invitation (ถ้ามี)",
    ],
    steps: [
      { title: "1. เลือกประเทศยื่น", desc: "ประเทศที่จะอยู่นานที่สุด หรือประเทศแรกที่เข้า" },
      { title: "2. จองคิว VFS", desc: "ยื่นที่ VFS / TLS ในกรุงเทพ" },
      { title: "3. Submit + Biometrics", desc: "ถ่ายลายนิ้วมือ + ส่งเอกสาร" },
      { title: "4. รอผล 15–45 วัน", desc: "ขึ้นกับประเทศและช่วงเวลา" },
    ],
    timeline: "วีซ่า 15–45 วัน",
    costRange: "6,000–12,000 บาท + ค่าธรรมเนียม 80 EUR",
    faqs: [
      {
        q: "ยื่นที่ประเทศไหนอนุมัติง่ายสุด?",
        a: "ขึ้นกับเคส — โดยทั่วไป สเปน เนเธอร์แลนด์ และฝรั่งเศสค่อนข้างยืดหยุ่นสำหรับ first-time traveler ที่มีเอกสารครบ",
      },
    ],
    relatedServiceSlugs: ["visa-schengen", "translation-certified-all", "mfa-consular"],
  },
  {
    slug: "china",
    nameTh: "จีน",
    nameEn: "China",
    flag: "🇨🇳",
    region: "เอเชีย",
    isApostille: true,
    language: "จีน",
    metaTitle: "บริการเอกสารไป China — Apostille + แปลจีน + L Visa",
    metaDesc: "บริการเอกสารและวีซ่าจีน — Apostille (จีนเข้าร่วม Nov 2023), แปลจีน, L Visa Tourist, M Visa Business บริการครบทั้งเอกสาร Apostille",
    intro:
      "จีนเข้าร่วม Apostille Convention เมื่อ พ.ย. 2023 — เอกสารไทยใช้ Apostille MFA ได้แล้ว ไม่ต้องไปสถานทูตจีนในไทยอีกต่อไปสำหรับเอกสารหลัก",
    whyUs: ["นักแปลจีน HSK 6 + native", "เข้าใจขั้นตอนใหม่หลัง Apostille"],
    visaServiceSlug: "visa-china-l",
    documentsRequired: [
      "Passport + รูปถ่าย China visa size",
      "ใบสมัครวีซ่าจีน + Itinerary",
      "จองตั๋วเครื่องบิน + โรงแรม",
      "Bank statement (ถ้าขอ M Visa)",
    ],
    steps: [
      { title: "1. เตรียมเอกสาร", desc: "Apostille (ถ้าเป็นเอกสารราชการ) + แปลจีน" },
      { title: "2. กรอกใบสมัคร Online", desc: "CVASC system" },
      { title: "3. ยื่นที่ CVASC", desc: "Bangkok / Chiang Mai / Songkhla" },
      { title: "4. รอผล 4–7 วันทำการ", desc: "L Visa Tourist หรือ M Business" },
    ],
    timeline: "วีซ่า 4–10 วันทำการ",
    costRange: "3,000–6,000 บาท + ค่าธรรมเนียม",
    faqs: [
      {
        q: "จีนเข้าร่วม Apostille แล้ว ยังต้องรับรองสถานทูตจีนไหม",
        a: "จีนเริ่มใช้ Apostille ตั้งแต่ 7 พ.ย. 2023 เอกสารราชการไทยที่มี Apostille จึงใช้ในจีนแผ่นดินใหญ่ได้โดยไม่ต้องผ่านสถานทูต แต่หน่วยงานจีนหลายแห่งยังขอคำแปลภาษาจีนที่จัดทำโดยหน่วยงานแปลที่เขายอมรับ",
      },
      {
        q: "คำแปลภาษาจีนต้องเป็นตัวย่อหรือตัวเต็ม",
        a: "จีนแผ่นดินใหญ่ใช้ตัวย่อ (Simplified) ส่วนฮ่องกง มาเก๊า ไต้หวันใช้ตัวเต็ม (Traditional) เราถามปลายทางก่อนเสมอเพื่อไม่ให้ต้องแปลซ้ำ",
      },
      {
        q: "ขอวีซ่าจีนต้องยื่นด้วยตัวเองไหม",
        a: "ต้องยื่นที่ CVASC และเก็บลายนิ้วมือด้วยตนเอง เว้นแต่เข้าข่ายยกเว้นตามประกาศ ทีมเราเตรียมชุดเอกสารและนัดคิวให้ ลดความเสี่ยงถูกขอเอกสารเพิ่ม",
      },
      {
        q: "เอกสารธุรกิจไปจีน (หนังสือรับรองบริษัท สัญญา) ต้องทำอะไรบ้าง",
        a: "โดยทั่วไปคือ รับรองลายมือชื่อ/สำเนาถูกต้องโดยทนายผู้ทำคำรับรองลายมือชื่อ → Apostille กรมการกงสุล → แปลจีน ทีมเราจัดลำดับให้ตรงกับที่คู่ค้าหรือหน่วยงานจีนร้องขอ",
      },
      {
        q: "จดทะเบียนสมรสกับคนจีนต้องใช้เอกสารอะไร",
        a: "ฝ่ายจีนต้องมีหนังสือรับรองสถานะโสดจากหน่วยงานจีนหรือสถานทูตจีนในไทย พร้อมคำแปลไทยรับรอง ส่วนฝ่ายไทยใช้เอกสารทะเบียนราษฎรตามปกติ",
      },
      {
        q: "ใบตรวจประวัติอาชญากรรมไทยใช้ยื่น Work Permit จีนได้ไหม",
        a: "ได้ โดยต้องผ่าน Apostille และแปลจีน หน่วยงานท้องถิ่นของจีนบางมณฑลกำหนดอายุเอกสารไม่เกิน 6 เดือน ควรตรวจกำหนดของมณฑลปลายทางก่อนยื่น",
      },
    ],
    relatedServiceSlugs: ["visa-china-l", "mfa-consular", "translation-certified-all"],
  },
];

export function getCountryBySlug(slug: string): CountryHub | undefined {
  return COUNTRIES.find((c) => c.slug === slug);
}

export const COUNTRY_REGIONS: CountryHub["region"][] = [
  "เอเชีย",
  "ยุโรป",
  "อเมริกาเหนือ",
  "โอเชียเนีย",
  "ตะวันออกกลาง",
];

export type { CountryHub } from "./types";